import { schema } from 'normalizr';

import { BrandingModel } from 'models';

export const brandingEntity = new schema.Entity('brandings');

export type NormalizeBrandingModelSchema = {
  brandings: Record<string, BrandingModel>;
};
